<!-- this component takes an article formgroup and displays the article fields accordingly -->
<ng-container *ngIf="articleFormGroup" [formGroup]="articleFormGroup">
    <div *ngIf="getVisibleArticleFieldsFormArray() >= 20">
        <ion-toolbar color="transparent">
            <ion-searchbar
                color="light"
                [cancelButtonText]="'shared.cancel' | translate"
                [placeholder]="'projects.jobs.details.article.search-article-placeholder' | translate"
                debounce="400"
                (ionCancel)="resetArticleSearch()"
                (ionClear)="resetArticleSearch()"
                [ngModelOptions]="{ standalone: true }"
                [(ngModel)]="articleSearchBarCurrentValue"
            ></ion-searchbar>
        </ion-toolbar>
    </div>
    <div class="job-article-wrap">
        <div
            *ngIf="viewMode === 'all' || viewMode === 'data-only'"
            class="job-article-fields"
            [ngClass]="{ 'field-display-dynamic': articleFormGroup.get('fieldDisplayType').value == 'dynamic' }"
        >
            <ng-container formArrayName="fields">
                <ng-container *ngFor="let articleField of getArticleFieldsFormArray().controls">
                    @if (!(articleField.get('hideInReport').value == true && authSrv.isViewerLicense)) {
                        <ng-container *ngIf="publicView; else normalArticleView">
                            <ng-container *ngIf="!utils.notAllowedFileTypesForPublicView.includes(articleField.get('type').value)">
                                <ng-container [ngTemplateOutlet]="articleFieldHtml"></ng-container>
                            </ng-container>
                        </ng-container>
                        <ng-template #normalArticleView>
                            <ng-container [ngTemplateOutlet]="articleFieldHtml"></ng-container>
                        </ng-template>

                        <ng-template #articleFieldHtml>
                            <div
                                class="job-article-field-wrap"
                                *ngIf="fieldVisibilityMapping[articleField.get('_id').value]"
                                [hidden]="!isFieldMatchingSearch(articleField)"
                                [style.flex-basis]="
                                    articleField.get('dynamicWidth').value != null ? articleField.get('dynamicWidth').value + '%' : 'auto'
                                "
                                [ngClass]="{ 'field-group': articleField.get('type').value == 'group' }"
                            >
                                <app-job-article-field
                                    [publicView]="publicView"
                                    [projectId]="project?._id"
                                    [jobId]="job?._id"
                                    [fieldFormGroup]="articleField"
                                    [changesAllowed]="changesAllowed"
                                    [linkFieldRelation]="
                                        jobExtensionId != null
                                            ? jobExtensionId === 'new-job-extension'
                                                ? jobExtensionId
                                                : 'job-extension#' + jobExtensionId
                                            : 'job#' + job?._id
                                    "
                                    [asDialog]="asDialog"
                                    (articleFieldFormGroupChanged)="handleArticleChangeEvents(false)"
                                    (duplicateGroup)="onDuplicateGroup($event)"
                                    (deleteDuplicatedGroup)="onDeleteDuplicatedGroup($event)"
                                    (lockRequested)="lockRequested.emit($event)"
                                    (jobSaveRequested)="jobSaveRequested.emit()"
                                    (removedJobLinkId)="removedJobLinkId.emit($event)"
                                    (addedJobLinkId)="addedJobLinkId.emit($event)"
                                ></app-job-article-field>
                            </div>
                        </ng-template>
                    }
                </ng-container>
                <div *ngIf="!hasSearchResults()" class="ion-text-center ion-padding">
                    <ion-text color="dark">{{ 'projects.jobs.details.article.no-search-results' | translate }} </ion-text>
                </div>
            </ng-container>
            <div class="job-article-reminder dp-mt-s" *ngIf="notificationReminderDate > 0">
                <small>
                    {{
                        'projects.jobs.details.article.reminder-text'
                            | translate
                                : {
                                      name: articleFormGroup.get('articleReminderName').value,
                                      date: (notificationReminderDate | date: 'dd.MM.YY'),
                                  }
                    }}
                </small>
            </div>
        </div>

        <ng-container *ngIf="getArticlePhotoCategoriesFormArray().length > 0 && viewMode !== 'data-only'">
            @if (!changesAllowed) {
                @for (category of getArticlePhotoCategoriesFormArray().value; track category.categoryName) {
                    @if (getAmountOfArticlePhotosByCategory(category.categoryName) > 0) {
                        <div class="job-article-photos-category">
                            <ng-container
                                [ngTemplateOutlet]="jobArticlePhotosCategory"
                                [ngTemplateOutletContext]="{ category: category }"
                            ></ng-container>
                        </div>
                    }
                }
            } @else {
                <div class="job-article-photos-category" *ngFor="let category of getArticlePhotoCategoriesFormArray().value">
                    <ng-container
                        [ngTemplateOutlet]="jobArticlePhotosCategory"
                        [ngTemplateOutletContext]="{ category: category }"
                    ></ng-container>
                </div>
            }

            <ng-template #jobArticlePhotosCategory let-category="category">
                <ion-card class="dp-mt-0 dp-ml-0 dp-mr-0">
                    <ion-card-header>
                        <ion-card-title
                            class="ion-display-flex ion-align-items-center ion-justify-content-between"
                            style="flex-wrap: nowrap"
                        >
                            <div class="ion-display-flex ion-align-items-center" style="min-width: 0; overflow: hidden">
                                <span style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap">{{
                                    category.categoryName
                                }}</span>
                                <span
                                    class="dp-pl-s ion-display-flex ion-align-items-center"
                                    dpTooltip
                                    [tooltipContent]="
                                        'projects.jobs.details.allowed-filetypes'
                                            | translate: { allowedFileTypes: getTranslatedFileTypes(category.fileType) }
                                    "
                                    tooltipTrigger="click mouseenter focus"
                                    tooltipPosition="top"
                                >
                                    @if (category.fileType.length === 1) {
                                        <ion-icon *ngIf="category.fileType.includes('image')" name="image-outline"></ion-icon>
                                        <ion-icon *ngIf="category.fileType.includes('video')" name="videocam-outline"></ion-icon>
                                        <ion-icon *ngIf="category.fileType.includes('audio')" name="musical-note-outline"></ion-icon>
                                        <ion-icon *ngIf="category.fileType.includes('pdf')" name="document-outline"></ion-icon>
                                    } @else {
                                        <ion-icon name="attach-outline"></ion-icon>
                                    }
                                </span>
                            </div>
                        </ion-card-title>
                    </ion-card-header>
                    <ion-card-content
                        cdkDropList
                        [cdkDropListDisabled]="!changesAllowed || publicView"
                        [cdkDropListData]="{
                            categoryName: category.categoryName,
                            articleFormGroup: articleFormGroup,
                            fileType: category.fileType,
                        }"
                        (cdkDropListDropped)="onDropPhoto($event, category.categoryName)"
                        (dragover)="$event.preventDefault()"
                        (drop)="onCategoryNativeDrop($event, category.categoryName)"
                    >
                        <div class="job-photo-list">
                            <ng-container *ngFor="let photo of getArticlePhotosFormArray().controls; index as photoIndex">
                                <div
                                    class="job-photo dp-mb-s"
                                    *ngIf="photo.value.photoCategoryName === category.categoryName"
                                    [attr.draggable]="changesAllowed"
                                    cdkDrag
                                    [cdkDragDisabled]="!utils.isPhone && !utils.isTablet && !altPressed"
                                    [cdkDragStartDelay]="utils.isPhone || utils.isTablet ? { touch: 100, mouse: 0 } : 0"
                                    [cdkDragData]="{
                                        photo: photo.value,
                                        sourceType: 'article',
                                        sourceCategoryName: category.categoryName,
                                        sourceArticleFormGroup: articleFormGroup,
                                    }"
                                    (cdkDragEntered)="onDragEntered($event)"
                                    (dragstart)="onPhotoDragStart($event, photo.value, category.categoryName)"
                                >
                                    <app-attachment-view
                                        [attachment]="photo.value"
                                        [publicImage]="getPublicImage(photo.value._id, category.categoryName)"
                                        (attachmentDeleted)="this.onRemovePhoto($event)"
                                        [canDelete]="changesAllowed"
                                        [canEdit]="changesAllowed"
                                        [showCreationTime]="showPhotoDate"
                                        [allowNotices]="true"
                                        (attachmentNoticeChanged)="onPhotoNoticeChanged(photo, $event)"
                                        (attachmentUpdated)="onPhotoUpdated(photo, $event)"
                                        [overrideDownloadFileName]="
                                            job.name.substring(0, 5) +
                                            '-' +
                                            job.jobNumber +
                                            '-' +
                                            category.categoryName +
                                            '-' +
                                            (photoIndex + 1)
                                        "
                                    ></app-attachment-view>
                                    <ng-template cdkDragPlaceholder>
                                        <div class="drag-placeholder" [ngClass]="!dragTargetAllowed ? 'drag-error' : ''">
                                            @if (!dragTargetAllowed) {
                                                {{ 'core.attachment.errors.file-type-not-allowed-err' | translate }}
                                            } @else {
                                                {{ 'projects.info.form.drop-attachment-here' | translate }}
                                            }
                                        </div>
                                    </ng-template>
                                    <ng-template cdkDragPreview matchSize="true">
                                        <div>
                                            <app-attachment-view
                                                [attachment]="photo.value"
                                                [canDelete]="false"
                                                [canEdit]="false"
                                                [allowNotices]="false"
                                                [showCreationTime]="false"
                                            ></app-attachment-view>
                                        </div>
                                    </ng-template>
                                </div>
                            </ng-container>
                        </div>
                        <ng-container *ngIf="changesAllowed && !category.readonly">
                            <hr class="divider" />
                            <div class="ion-text-center">
                                <app-attachment-select
                                    [noUpload]="publicView"
                                    [dialog]="false"
                                    [allowedFileTypes]="category.fileType"
                                    [folder]="project?._id + '/jobs/' + job._id"
                                    [lockCameraOrientation]="category.lockCameraOrientation"
                                    (fileSelected)="onAddPhoto($event, category.categoryName)"
                                    (noUploadFileSelected)="noUploadedFilesChanged($event, category.categoryName)"
                                    [buttonText]="'projects.info.form.photo.upload-btn' | translate"
                                ></app-attachment-select>
                            </div>
                        </ng-container>
                    </ion-card-content>
                </ion-card>
            </ng-template>
        </ng-container>
    </div>
</ng-container>
